export default __webpack_public_path__ + "locales/tr/Settings.json?hash=cbceba92cf42679e5c2ace43938cbfef";